import styled from '@emotion/styled';

import { authColors, authLayout, authRadius } from 'design-system/tokens';

const TAG_BG = '#E5FFFF';
const TAG_BORDER = '#00FFFF';
const TAG_TEXT = '#003333';
const NEUTRAL = '#8C8C8C';

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(0, 0, 0, 0.4);
`;

export const Panel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  gap: 24px;
  width: 742px;
  max-width: 100%;
  max-height: 92vh;
  padding: 24px;
  overflow-y: auto;
  background: ${authColors.white};
  border-radius: 16px;
`;

export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  align-self: stretch;
`;

export const HeaderTexts = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.h2`
  margin: 0;
  font-family: 'Mangueira', sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  color: #000000;
`;

export const Text = styled.p`
  margin: 0;
  font-family: 'Mangueira', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  color: #000000;
`;

export const CloseButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  padding: 0;
  border: none;
  background: transparent;
  color: ${authColors.textStrong};
  cursor: pointer;

  svg {
    width: 16px;
    height: 16px;
  }

  &:focus-visible {
    outline: 2px solid ${authColors.brand};
    outline-offset: 2px;
    border-radius: 4px;
  }
`;

export const ModelText = styled.p`
  margin: 0;
  max-width: 425px;
  font-family: 'Mangueira', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  color: ${authColors.textStrong};
`;

export const ModelName = styled.strong`
  font-weight: 700;
  color: ${authColors.brand};
`;

export const ModelField = styled.strong`
  font-weight: 700;
  color: ${authColors.textStrong};
`;

export const ModelImage = styled.img`
  width: 710px;
  max-width: 100%;
  height: auto;

  @media (max-width: ${authLayout.mobileBreakpoint}) {
    width: 266px;
  }
`;

export const Tag = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  gap: 4px;
  max-width: 536px;
  padding: 8px 12px;
  background: ${TAG_BG};
  border: 1px solid ${TAG_BORDER};
  border-radius: ${authRadius.pill};
  font-family: 'Mangueira', sans-serif;
  font-size: 12px;
  font-weight: 700;
  line-height: 14px;
  color: ${TAG_TEXT};

  svg {
    flex-shrink: 0;
    width: 12px;
    height: 12px;
  }

  @media (max-width: ${authLayout.mobileBreakpoint}) {
    order: 1;
    max-width: 208px;
    font-size: 10px;
    border-radius: 16px;
  }
`;

export const Buttons = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  width: 342px;
  max-width: 100%;

  @media (max-width: ${authLayout.mobileBreakpoint}) {
    order: 0;
    width: 100%;
  }
`;

const baseButton = `
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  flex: 1;
  gap: 8px;
  min-width: 98px;
  max-width: 340px;
  height: 48px;
  padding: 12px 16px;
  border-radius: 1000px;
  font-family: 'Mangueira', sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  cursor: pointer;

  svg {
    flex-shrink: 0;
    width: 24px;
    height: 24px;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const PreviousButton = styled.button`
  ${baseButton}
  background: transparent;
  border: 1px solid ${NEUTRAL};
  color: ${NEUTRAL};
`;

export const NextButton = styled.button`
  ${baseButton}
  background: ${authColors.brand};
  border: none;
  color: ${authColors.white};
`;
